import StaysList from './StaysList';
export type { StaysListProps } from './StaysLists.types';

export default StaysList;
